 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLFRONTMATTER from '@/components/xhtml/frontmatter'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/acknowledgments'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLINTRODUCTION from '@/components/xhtml/introduction'
 import XHTMLFRONTMATTER01 from '@/components/xhtml/frontmatter01'
 import XHTMLCHAPTER01 from '@/components/xhtml/chapter01'
 import XHTMLCHAPTER01A from '@/components/xhtml/chapter01a'
 import XHTMLCHAPTER02 from '@/components/xhtml/chapter02'
 import XHTMLCHAPTER02A from '@/components/xhtml/chapter02a'
 import XHTMLCHAPTER02B from '@/components/xhtml/chapter02b'
 import XHTMLCHAPTER02C from '@/components/xhtml/chapter02c'
 import XHTMLCHAPTER02D from '@/components/xhtml/chapter02d'
 import XHTMLCHAPTER02E from '@/components/xhtml/chapter02e'
 import XHTMLCHAPTER02F from '@/components/xhtml/chapter02f'
 import XHTMLCHAPTER02G from '@/components/xhtml/chapter02g'
 import XHTMLCHAPTER02H from '@/components/xhtml/chapter02h'
 import XHTMLCHAPTER02I from '@/components/xhtml/chapter02i'
 import XHTMLCHAPTER03 from '@/components/xhtml/chapter03'
 import XHTMLCHAPTER03A from '@/components/xhtml/chapter03a'
 import XHTMLCHAPTER03B from '@/components/xhtml/chapter03b'
 import XHTMLCHAPTER03C from '@/components/xhtml/chapter03c'
 import XHTMLCHAPTER03D from '@/components/xhtml/chapter03d'
 import XHTMLCHAPTER03E from '@/components/xhtml/chapter03e'
 import XHTMLCHAPTER03F from '@/components/xhtml/chapter03f'
 import XHTMLCHAPTER03G from '@/components/xhtml/chapter03g'
 import XHTMLCHAPTER04 from '@/components/xhtml/chapter04'
 import XHTMLCHAPTER04A from '@/components/xhtml/chapter04a'
 import XHTMLCHAPTER04B from '@/components/xhtml/chapter04b'
 import XHTMLCHAPTER04C from '@/components/xhtml/chapter04c'
 import XHTMLCHAPTER04D from '@/components/xhtml/chapter04d'
 import XHTMLCHAPTER04E from '@/components/xhtml/chapter04e'
 import XHTMLCHAPTER04F from '@/components/xhtml/chapter04f'
 import XHTMLCHAPTER04G from '@/components/xhtml/chapter04g'
 import XHTMLCHAPTER04H from '@/components/xhtml/chapter04h'
 import XHTMLCHAPTER04I from '@/components/xhtml/chapter04i'
 import XHTMLCHAPTER04J from '@/components/xhtml/chapter04j'
 import XHTMLCHAPTER04K from '@/components/xhtml/chapter04k'
 import XHTMLCHAPTER04L from '@/components/xhtml/chapter04l'
 import XHTMLCHAPTER04M from '@/components/xhtml/chapter04m'
 import XHTMLCHAPTER05 from '@/components/xhtml/chapter05'
 import XHTMLCHAPTER05A from '@/components/xhtml/chapter05a'
 import XHTMLCHAPTER05B from '@/components/xhtml/chapter05b'
 import XHTMLCHAPTER05C from '@/components/xhtml/chapter05c'
 import XHTMLCHAPTER05D from '@/components/xhtml/chapter05d'
 import XHTMLCHAPTER05E from '@/components/xhtml/chapter05e'
 import XHTMLCHAPTER05F from '@/components/xhtml/chapter05f'
 import XHTMLCHAPTER05G from '@/components/xhtml/chapter05g'
 import XHTMLCHAPTER05H from '@/components/xhtml/chapter05h'
 import XHTMLCHAPTER05I from '@/components/xhtml/chapter05i'
 import XHTMLCHAPTER05J from '@/components/xhtml/chapter05j'
 import XHTMLCHAPTER05K from '@/components/xhtml/chapter05k'
 import XHTMLCHAPTER05L from '@/components/xhtml/chapter05l'
 import XHTMLCHAPTER05M from '@/components/xhtml/chapter05m'
 import XHTMLCHAPTER05N from '@/components/xhtml/chapter05n'
 import XHTMLCHAPTER05O from '@/components/xhtml/chapter05o'
 import XHTMLCHAPTER05P from '@/components/xhtml/chapter05p'
 import XHTMLCHAPTER05Q from '@/components/xhtml/chapter05q'
 import XHTMLCHAPTER05R from '@/components/xhtml/chapter05r'
 import XHTMLCHAPTER06 from '@/components/xhtml/chapter06'
 import XHTMLCHAPTER06A from '@/components/xhtml/chapter06a'
 import XHTMLCHAPTER06B from '@/components/xhtml/chapter06b'
 import XHTMLCHAPTER06C from '@/components/xhtml/chapter06c'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLSOURCE from '@/components/xhtml/source'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLTABLE from '@/components/xhtml/table'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/introduction",
 			"name" : "xhtml/introduction",
 			"component" : XHTMLINTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js